import React, { useReducer } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {
    UserContext,
    UserDispatchContext,
    initialUser,
    userReducer,
} from './store/user';

const AppComponent = () => {
    const [user, dispatch] = useReducer(userReducer, initialUser);

    return (
        <UserContext.Provider value={user}>
            <UserDispatchContext.Provider value={dispatch}>
                <App />
            </UserDispatchContext.Provider>
        </UserContext.Provider>
    );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<AppComponent />);
